import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import MentalRiskCharts from '../common/charts/MentalRiskCharts';
import PreventionChart from '../common/charts/PreventionChart';
import Methodology from '../common/Methodology';
import Related from '../common/Related.js';

import { preventionInCompanies } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

const PreventionCompanies = props => {

	let selected = '';
	for (let i = 0; i < preventionInCompanies.length; i++)
	{
		if (preventionInCompanies[i].url == props.indicator)
		{
			selected = preventionInCompanies[i];
		}
	}

	const currentPath = `/working-conditions-preventions/prevention-companies/`;

	const [lockedCountry, setLockedCountry] = useState(props.lockedCountry);
	const [split, setSplit] = useState(props.split);
	const [selectMenu, setSelectMenu] = useState([{ literalTab: '20679' }, { literalTab: '20683' }]);
	const [selectChart, setSelectChart] = useState([{ literalTab: '20680' }, { literalTab: '20682' }]);
	const [selectedTab, setSelectedTab] = useState(selected);
	const [selectedSurvey, setSelectedSurvey] = useState(props.dataset);
	const [chartLegend, setChartLegend] = useState(selected.chartType[0].legend);
	const [chartDimension, setChartDimension] = useState(window.innerWidth > 768 ? 'column': 'bar');
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (props.country1 != undefined && props.country2 != undefined && props.country3 != undefined) {
			props.setCountry1(props.country1);
			props.setCountry2(props.country2);
			props.setCountry3(props.country3);
		}

		// Update the title of the page
		document.title = props.literals.L22014 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
		window.addEventListener('resize', updateDimension);
	}, [])

	useEffect(() => {
		setSelectedSurvey(props.dataset);
	}, [props.dataset])

	useEffect(() => {
		callbackSelectedTab(props.indicator);
	}, [props.indicator])

	const handleSearch = (callbackCountry1) =>{
		if (!props.selectedByUser) {
			props.setCountry1(callbackCountry1)
		} else {
			setLockedCountry(callbackCountry1);
		}
	}

	const handleSearch2 = (callbackCountry2) =>{
		props.setCountry2(callbackCountry2);
	}

	const handleSearch3 = (callbackCountry3) =>{
		props.setCountry3(callbackCountry3);
	}

	const updateDimension = () => {
		if (window.innerWidth > 768){
			setChartDimension('column');
		}else{
			setChartDimension('bar');
		}
	}

	const callbackChartLegend = (legend) => {
		setChartLegend(legend);
	}

	const callbackSelectedSurvey = (callback) => {
		setSplit(callback == 'establishment size' ? 'size' : callback);
	}

	const callbackSelectedTab = (callback) => {
		for (let i = 0; i < preventionInCompanies.length; i++)
		{
			if (preventionInCompanies[i].url == callback)
			{
				setSelectedTab(preventionInCompanies[i]);
				if (callback == "evaluated-aspects-in-risk-assessments")
				{
					// The selected tab is the Eavluated Aspects in Risks Assessment, the Footer text must be set manually
					setChartLegend(preventionInCompanies[i].chartType[0].legend);
				}
			}
		}
	}

	return(
		<div className="prevention-companies">
			<AdviceSection literals={ props.literals } section={["working-conditions-preventions","prevention-companies"]} methodologyData={{section: 'working-conditions-preventions', subsection:'Prevention in companies', indicator: 304}} />

			<SubMenuTabs 
				literals={ props.literals }
				callbackSelectedTab={ callbackSelectedTab }
				selectedTab={ selectedTab.url } 
				subMenuTabs={ preventionInCompanies }
				locationPath={ currentPath }
				selectCountry1={ props.selectedByUser ? lockedCountry : props.selectCountry }
				selectCountry2= { props.selectCountry2 }
				selectCountry3 = { props.selectCountry3 }
				split={ split }
			/>
			<div className="line background-main-light" />

			{( selectedTab.url == 'risk-assessment' || selectedTab.url == 'employees-participation-in-prevention' ) && (
				<SelectEconomic 
					handleSearch={ handleSearch } 
					handleSearch2={ handleSearch2 } 
					handleSearch3={ handleSearch3 }
					charts={ [ selectedTab.chartType[0].chart ] }
					indicator={ selectedTab.chartType[0].chartIndicator }
					literals={ props.literals }
					selectedCountry1={ props.selectedByUser ? lockedCountry : props.selectCountry }
					selectedCountry2={ props.selectCountry2 }
					selectedCountry3={ props.selectCountry3 }
				/>
			)}			

			<div className="line background-main-light"></div>
			<div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text" >
				<div className="card--block--chart" >
					<div className="chart--block with-filter" >
						<div className="card--block--chart--wrapper" >
							{ preventionInCompanies.map((tab) => {
								if (tab.url == selectedTab.url) {
									return (
										<div className="chart--wrapper" key={tab.literalTab} >
											{ selectedTab.url == 'internal-or-external-ra' && (
												<MentalRiskCharts
													literals={ props.literals }
													tabIndicator={ tab.literalTab }
													chartType={ tab.chartType }
													colors={ ['#7b7b7d', '#cbe2e3','#f6a400'] }
													type={ chartDimension }
													percentage={ true }
													callbackLegend={ callbackChartLegend }
													callbackSelectedSurvey={ callbackSelectedSurvey }
													exportingEnabled={ true }
													showSelect={ true }
													showDatasetSelect={ true }
												/>
											)}
											{ selectedTab.url == 'training-in-osh' && (
												<MentalRiskCharts
													literals={ props.literals }
													tabIndicator={ tab.literalTab }
													chartType={ tab.chartType }
													colors={ ['#7b7b7d', '#cbe2e3','#f6a400'] }
													type={ chartDimension }
													percentage={ true }
													callbackLegend={ callbackChartLegend }
													callbackSelectedSurvey={ callbackSelectedSurvey }
													exportingEnabled={ true }
													showSelect={ true }
													showDatasetSelect={ true }
												/>
											)}
											{ selectedTab.url == 'risk-assessment' && (
												<PreventionChart
													literals={ props.literals }
													tabIndicator={ tab.literalTab }
													chartType={ tab.chartType }
													showDataLabel={ true }
													colors={ ['#f6a400', '#003399','#cbe2e3','#7B7B7D'] }
													type={ chartDimension }
													percentage={ true }
													callbackLegend={ callbackChartLegend }
													callbackSelectedSurvey={ callbackSelectedSurvey }
													selectedCountry1={ props.selectedByUser ? lockedCountry : props.selectCountry }
													selectedCountry2={ props.selectCountry2}
													selectedCountry3={ props.selectCountry3}
													exportingEnabled={ true }
													showSelect={ true }
												/>
											)}
											{ selectedTab.url == 'employees-participation-in-prevention' && (
												<PreventionChart
													literals={ props.literals }
													tabIndicator={ tab.literalTab }
													chartType={ tab.chartType }
													colors={ ['#f6a400', '#003399','#cbe2e3','#7B7B7D'] }
													type={ chartDimension }
													percentage={ true }
													callbackLegend={ callbackChartLegend }
													callbackSelectedSurvey={ callbackSelectedSurvey }
													selectedCountry1={ props.selectedByUser ? lockedCountry : props.selectCountry}
													selectedCountry2={ props.selectCountry2}
													selectedCountry3={ props.selectCountry3}
													exportingEnabled={ true }
													showSelect={ true }
												/>
											)}
											{ selectedTab.url == 'evaluated-aspects-in-risk-assessments' && (
												<div className='chart-container'>
													<h2 className='title--card'>{ props.literals.L20681 }</h2><br/>
													<a href='https://visualisation.osha.europa.eu/esener/en/survey/detailpage-european-map/2019/osh-management/en_1/E3Q252_1/activity-sector/14/11/1' target='_blank'>
														<img src={require('../../style/img/EU-map.png')} alt=""/>
													</a>
													<p>{ props.literals.L20738 }</p>
												</div>
											)}
										</div>
									)
								}
							})}	
						</div>
					</div>
				</div>
				<div className="chart-legend">
					{ReactHtmlParser(props.literals[`L${chartLegend}`])}
				</div>
			</div>

			{ selectedTab.url != 'evaluated-aspects-in-risk-assessments' && (
				<Methodology literals={ props.literals } section={ 'Prevention in companies' } indicator={ selectedTab.chartType[0].chartIndicator } />
			)}
			<Related literals={ props.literals } section={["working-conditions-preventions","prevention-companies", selectedTab.url]} />
		</div>
	)
}
PreventionCompanies.displayName = 'PreventionCompanies';

function mapStateToProps(state){
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = state.selectCountries;
    return { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry };
}

function mapDispatchToProps(dispatch) {
	return {
		setCountry1: (country) => dispatch(setCountry1(country)),
		setCountry2: (country2) => dispatch(setCountry2(country2)),
		setCountry3: (country3) => dispatch(setCountry3(country3))
	}
}

export default connect(mapStateToProps, mapDispatchToProps )(PreventionCompanies);